<template lang="pug">
div
  slot(
    name="activator"
    :generate="generatePDF"
    :loading="loading"
  )
  vue-html2pdf(
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :paginate-elements-by-height="1969"
    :pdf-quality="2"
    :manual-pagination="true"
    :html-to-pdf-options="options"
    pdf-content-width="600px"
    ref="html2Pdf"
    @beforeDownload="loading = true"
    @hasDownloaded="loading = false"
  )
    //- @progress="onProgress($event)"
    div(slot="pdf-content")
      slot
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'HtmlToPdf',

  components: { VueHtml2pdf },

  props: {
    fileName: { type: String, default: 'File' },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    options() {
      return {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: this.fileName,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, useCORS: true },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait',
        },
      };
    },
  },

  methods: {
    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>
